import { render, staticRenderFns } from "./GBLayerChart.vue?vue&type=template&id=4c88cb1c&"
import script from "./GBLayerChart.vue?vue&type=script&lang=js&"
export * from "./GBLayerChart.vue?vue&type=script&lang=js&"
import style0 from "./GBLayerChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports